<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Policy Violations</h3>
    </div>
    <div class="card-section">
        <div class="card-panel">
            <div class="edit-form-panel">
                <form [formGroup]="policyViolationForm">
                    <div class="field-form-panel">
                        <h4>{{policyViolationID > 0 || contactId > 0 ? memPolicyViolation?.contactName : 'Add'}}</h4>
                        <hr />
                        <div class="flex-form contracts-flex-form">
                            <div class="form-group">
                                <label>Total Fee Due By Member</label>
                                <input class="form-control" type="text" formControlName="totalFeeDueByMember" />
                            </div>
                            <div class="form-group">
                                <label>Total Fee Paid By Member</label>
                                <input class="form-control" type="text" formControlName="totalFeePaidByMember" />
                            </div>
                            <div class="form-group">
                                <label>Fee Amount</label>
                                <input class="form-control" type="text" formControlName="feeAmount" />
                            </div>
                            <div class="form-group">
                                <label>Late Arrival Time</label>
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="lateArrivalTime" class="form-control" formControlName="lateArrivalTime" id="lateArrivalTime">
                                    <mat-datepicker-toggle matSuffix [for]="lateArrivalTime"></mat-datepicker-toggle>
                                    <mat-datepicker #lateArrivalTime></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Fee Notes</label>
                                <input class="form-control" type="text" formControlName="feeNotes" />
                            </div>
                        </div>
                        <div class="flex-form contracts-flex-form">
                            <div class="form-group">
                                <label>Fee date</label>
                                <mat-form-field>
                                    <input matInput #ref [matDatepicker]="feeDate" class="form-control" formControlName="feeDate" id="feeDate">
                                    <mat-datepicker-toggle matSuffix [for]="feeDate"></mat-datepicker-toggle>
                                    <mat-datepicker #feeDate></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="form-group">
                                <label>Fee Type</label>
                                <select class="form-control" formControlName="feeTypeID">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of feeTypeDD" [value]="item.statusID">{{item?.status}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Policy Violation Found</label>
                                <select class="form-control" formControlName="noPolicyViolationFound">
                                    <option [value]="true">Yes</option>
                                    <option [value]="false">No</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Warning Issued</label>
                                <select class="form-control" formControlName="warningIssued">
                                    <option [value]="true">Yes</option>
                                    <option [value]="false">No</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Case Owner</label>
                                <select class="form-control" formControlName="caseOwnerId">
                                    <option *ngFor="let opt of clpUsersDD" [value]="opt.value">
                                        {{ opt.text }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group" *ngIf="policyViolationID == 0 && contactId == 0">
                                <label>Contact</label>
                                <select class="form-control" formControlName="contactId" (change)="onChangeMemContact()">
                                    <option value="0">--Select--</option>
                                    <option *ngFor="let item of memContact_dd" [value]="item.id">{{item?.text}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <button type="button" class="primary-btn" *ngIf="policyViolationID > 0 || contactId > 0" (click)="memPolicyViolation_Update()">Update</button>
                    <button type="button" class="primary-btn" *ngIf="policyViolationID > 0 || contactId > 0" (click)="memPolicyViolation_Delete()">Delete</button>
                </form>
            </div>

        </div>
    </div>
</div>

